export default __webpack_public_path__ + "static/media/web-design-brush.1fc947ae.svg";